
export interface GetDailyKmAndFuelReportListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDailyKmAndFuelReportListPagingAndFilterResponseData
}

export interface GetDailyKmAndFuelReportListPagingAndFilterResponseData {
    totalRecordCount: number
    items: GetDailyKmAndFuelReportListPagingAndFilterResponseItem[]
}

export interface GetDailyKmAndFuelReportListPagingAndFilterResponseItem {
    plate: string
    gpsDate: string
    gpsDateStr: string
    maxGpsDateTime: string
    maxGpsDateTimeStr: string
    maxTotalKmDaily: number
    maxDailySpentFuel: number
}

export const initialGetDailyKmAndFuelReportListPagingAndFilterResponseData: GetDailyKmAndFuelReportListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}